__turbopack_context__.v({
  "tooltip": "tooltip-module__cfZ4zG__tooltip",
});
